import React, {Fragment, useState} from "react";
import blackBackground from "../../assets/pictures/old-black-background.jpg";
import {StateContext} from "../../containers/sidebarContext";
import CoverBoxes from "../CoverBoxes";
import shelbyBarLogo from "../../assets/pictures/shelbyLogo-removebg.png";
import LoadingSpinner from "../Spinner";

import { useTranslation } from 'react-i18next';

const StartPage = () => {
    const state = React.useContext(StateContext);
    const {isSidebarOpen} = state;

    const [isLoading, setIsLoading] = useState(true);
    const { t } = useTranslation();

    const handleFetch = () => {
        setIsLoading(true);
        setTimeout(function(){
            setIsLoading(false);
        }, 400);
    };

    return (
        <Fragment>
            {isLoading ? <LoadingSpinner handleFetch={handleFetch}/> :
            isSidebarOpen &&
            <>
                <div
                    style={{
                        backgroundImage: `url(${blackBackground})`,
                        backgroundSize: "cover",
                    }}
                    className="home__box"
                >
                    <div>
                          <span className="home__page-logo">
                                <img className="navbar-logo-position" src={shelbyBarLogo} alt="flowers"/>
                            </span>
                       <p>{t("homepage:title")}</p>
                        <p>{t("homepage:description")}
                        </p>
                    </div>

                </div>
                <CoverBoxes/>
            </>
            }
        </Fragment>
    );
};

export default StartPage;
